import { Action } from 'redux';

export enum GlobalActionConstants {
  HTTP_UNAUTHORIZED_NOTIFY = '@@global/HTTP_UNAUTHORIZED_NOTIFY',
  HTTP_UNAUTHORIZED_DISMISS = '@@global/HTTP_UNAUTHORIZED_DISMISS',
}

export type ReduxAction<TArgs, TConstant = unknown> = TArgs & Action<TConstant>;
export type DispatchFunc<TArgs, TConstant = unknown> = (args?: TArgs) => TArgs & Action<TConstant>;

export function createReduxAction<TArgs, TConstant>(type: TConstant) {
  return (args?: TArgs) => ({
    type,
    ...args,
  }) as ReduxAction<TArgs, TConstant>;
}

export function makeActionCreator<TConstant>() {
  return <TArgs>(type: TConstant) => createReduxAction<TArgs, TConstant>(type);
}
